var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"title-bar__coins",attrs:{"to":{ name: 'ShowProductsPage' }}},[_c('CoinsImage',{staticClass:"coins__img"}),_c('span',{staticClass:"coins__amount",attrs:{"data-test-id":"coins__amount"}},[_vm._v(" "+_vm._s(_vm.coinsBalance)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }